import createKey from './create';
import deleteKey from './delete';
import listKeys from './list';
export const baseUrl = "/company/:company_id/keys";
export default (axiosConfig, options) => ({
  create: createKey(axiosConfig, options),
  list: listKeys(axiosConfig, options),
  delete: deleteKey(axiosConfig, options)
});